<template>
    <HeaderList></HeaderList>
    <div class="detail relative pt-12 h-full bg-theme-gray">
        <ProductView></ProductView>
    </div>    
</template>
<script type="text/javascript" src="">
import HeaderList from '@/components/HeaderList.vue';
import ProductView from '@/components/ProductView.vue';

export default {
    name: 'Group',
    components: {
        HeaderList,
        ProductView
    }
};
</script>